import React from 'react';
import { Box, Flex, Text } from 'theme-ui';
import styles from './styles';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper/LayoutWrapper';
import Reveal from '@solid-ui-components/Reveal/Reveal';

const BenefitsPercentage = ({ content }) => {
  return (
    <LayoutWrapper>
      <Flex sx={styles.container}>
        {content.text.map((item, index) =>
          item.variant === 'h1' ? (
            <Box key={index} sx={styles.item}>
            <Reveal effect={'fadeInDeepLeft'}>
              <Text sx={styles.percentage}>{item.text}</Text>
              {content.text[index + 1] && content.text[index + 1].variant === 'p' && (
                <Text sx={styles.description}>{content.text[index + 1].text}</Text>
              )}
            </Reveal>
            </Box>
          ) : null
        )}
      </Flex>
    </LayoutWrapper>
  );
};

export default BenefitsPercentage;
